import template from './tableGridErrorReportCell.html';
import controller from './tableGridErrorReportCell.controller';

let tableGridErrorReportCellComponent = () => {
  return {
    restrict: 'E',
    replace: false,
    scope: {
      row: '=',
      columnName: '@',
      metaData: '=',
      options: '='
    },
    template,
    controller,
    controllerAs: 'vm',
    link: {
      pre: (scope) => {
        scope.vm.batchId = scope.row.id;
        scope.vm.getErrors();
        scope.vm.status = scope.row.status;
      }
    }
  };
};

export default tableGridErrorReportCellComponent;



// WEBPACK FOOTER //
// ./app/components/tableGridErrorReportCell/tableGridErrorReportCell.component.js